import React from 'react';
import { Icon } from '../../../../shared/Icon/index.tsx';
import { clickedFooterLink } from '../../events';

import styles from './styles.sass';

function SocialLink({ platformName }) {
  const { url, component } = getPlatformInfo(platformName);
  return (
    <a
      className={styles.iconLink}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => clickedFooterLink(platformName)}
    >
      {component}
    </a>
  );
}

function getPlatformInfo(platformName) {
  switch (platformName) {
    case 'twitter':
      return {
        url: 'https://twitter.com/anchor',
        component: (
          <Icon
            type="TwitterLogo"
            svgClassName={styles.svg}
            fillColor="#C9CBCD"
          />
        ),
      };
    case 'facebook':
      return {
        url: 'https://www.facebook.com/anchor.fm/',
        component: (
          <Icon
            type="FacebookLogo"
            svgClassName={styles.svg}
            fillColor="#C9CBCD"
          />
        ),
      };
    case 'instagram':
      return {
        url: 'https://www.instagram.com/anchor.fm/',
        component: (
          <Icon
            type="Instagram"
            svgClassName={styles.svg}
            fillColor="#C9CBCD"
          />
        ),
      };
    default:
      return null;
  }
}

export { SocialLink };
